module.exports = __webpack_public_path__ + "assets/img/tik-tok.977d9c9f.svg";